var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewVulnerableAssetFound = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    viewBox: "0 0 27 27",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D5B66",
    d: "M11.12 18.639c0 .191.156.346.347.346h4.352a.347.347 0 0 0 .347-.346v-1.044h7.759V5.107a.38.38 0 0 0-.382-.383H3.975c-.21 0-.382.171-.382.383v12.488h7.528zm3.264-10.99.905-.904a.39.39 0 1 1 .55.552l-.903.904a.39.39 0 0 1-.552 0 .39.39 0 0 1 0-.552m-.95-1.463a.39.39 0 0 1 .78 0v1.279a.39.39 0 0 1-.78 0zm-1.756.559a.39.39 0 0 1 .551 0l.905.904a.392.392 0 0 1-.276.666.4.4 0 0 1-.276-.114l-.904-.904a.39.39 0 0 1 0-.552m-1.362 8.302a3.01 3.01 0 0 1-3.007-3.007 3.01 3.01 0 0 1 3.007-3.007h2.189a.78.78 0 0 1 0 1.56h-2.19a1.448 1.448 0 0 0 0 2.894h2.19a.78.78 0 0 1 0 1.56zM17.58 19.37a1.91 1.91 0 0 1-1.76 1.175h-4.353a1.91 1.91 0 0 1-1.76-1.175H1.87v.605c0 .866.702 1.568 1.568 1.568H24.08c.866 0 1.568-.702 1.568-1.568v-.605z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.22 15.047H15.03a.78.78 0 0 1 0-1.56h2.189a1.449 1.449 0 0 0 0-2.895H15.03a.78.78 0 0 1 0-1.56h2.189a3.01 3.01 0 0 1 3.007 3.007 3.01 3.01 0 0 1-3.007 3.008"
  })));
};
export default SvgNewVulnerableAssetFound;